// utils/analytics.ts
import posthog from "posthog-js";

// Initialize PostHog (already done in index.tsx or _app.tsx)

export const initPosthog = () => {
  const key = process.env.REACT_APP_POSTHOG_KEY;
  const host = process.env.REACT_APP_POSTHOG_HOST;

  if (!key || !host) {
    console.warn("PostHog key/host not found in env");
    return;
  }

  posthog.init(key, {
    api_host: host,
    capture_pageview: true,
    persistence: 'localStorage',
    capture_performance: true,
    loaded: (posthog) => {
      // Register super properties
      posthog.register({
        app_version: process.env.REACT_APP_VERSION,
        environment: process.env.NODE_ENV,
        platform: 'web',
        subdomain: window.location.hostname.split('.')[0]
      });
      
      if (window.location.hostname === 'localhost') {
        posthog.opt_out_capturing();
      }
    }
  });
};

export const FinkAnalytics = (eventName, eventProps = {}) => {
  if (typeof window !== "undefined" && posthog?.capture) {
    posthog.capture(eventName, eventProps);
    console.log(`✅ PostHog: Fired ${eventName}`, eventProps);
  } else {
    console.warn("🚫 PostHog not available yet");
  }
};
